export const PLATFORMS = {
  telegram: { id: 'telegram', name: 'Telegram', color: '#229ED9', bg: '#E3F4FC', textColor: '#0C6B96', short: 'TG' },
  whatsapp: { id: 'whatsapp', name: 'WhatsApp', color: '#25D366', bg: '#E1F5E9', textColor: '#1A6B36', short: 'WA' },
  wecom: { id: 'wecom', name: '企业微信', color: '#07C160', bg: '#E4F7EC', textColor: '#116B3A', short: '企微' },
  teams: { id: 'teams', name: 'Teams', color: '#6264A7', bg: '#EDEBFF', textColor: '#3730A3', short: 'Teams' },
  email: { id: 'email', name: 'Email', color: '#EA4335', bg: '#FDECEA', textColor: '#9C1B14', short: '邮件' },
  facebook: { id: 'facebook', name: 'Facebook', color: '#1877F2', bg: '#E7F0FD', textColor: '#0C4FA8', short: 'FB' },
  instagram: { id: 'instagram', name: 'Instagram', color: '#E1306C', bg: '#FDEAF1', textColor: '#8B0D3A', short: 'INS' },
};

export const STAGES = ['初次接触', '产品沟通', '发送报价', '谈判中', '已成交'];

export const CONTACTS = {
  'c1': {
    id: 'c1', name: 'Mohammed K.', company: 'Al-Khalid Trading', country: '🇸🇦 沙特阿拉伯',
    avatarBg: '#C0DD97', avatarColor: '#3B6D11', initials: 'MK',
    platforms: ['telegram', 'whatsapp'], stage: 1,
    tags: ['LED灯带', '意向强', '大客户', '户外用途'],
    assignee: { name: '李小红', initials: '李' },
    notes: '客户做户外工程，需要IP68防水等级，对价格敏感，建议先发样品。',
    orders: [],
    reminders: [{ id: 'r1', text: '发送IP68详细报价单', time: '明天 10:00' }],
  },
  'c2': {
    id: 'c2', name: 'Sarah A.', company: 'Bright Solutions LLC', country: '🇦🇪 阿联酋',
    avatarBg: '#F5C4B3', avatarColor: '#993C1D', initials: 'SA',
    platforms: ['whatsapp'], stage: 2,
    tags: ['工业照明', '复购客户'],
    assignee: { name: '王强', initials: '王' },
    notes: '老客户，去年采购过两批，本次询价工业照明系列。',
    orders: [{ id: 'o1', title: '订单 #2023-112', amount: '$12,400', date: '2023-08-15' }],
    reminders: [],
  },
  'c3': {
    id: 'c3', name: 'Dmitri N.', company: 'EuroLight GmbH', country: '🇩🇪 德国',
    avatarBg: '#CECBF6', avatarColor: '#3C3489', initials: 'DN',
    platforms: ['email'], stage: 3,
    tags: ['欧洲市场', 'CE认证', '大单'],
    assignee: { name: '李小红', initials: '李' },
    notes: '需要CE/RoHS认证文件，对产品质量要求高，价格次之。',
    orders: [],
    reminders: [{ id: 'r2', text: '提供CE认证文件', time: '本周五' }],
  },
  'c4': {
    id: 'c4', name: 'Laura C.', company: 'Meridian Imports', country: '🇧🇷 巴西',
    avatarBg: '#9FE1CB', avatarColor: '#085041', initials: 'LC',
    platforms: ['whatsapp'], stage: 1,
    tags: ['南美市场', '新客户'],
    assignee: { name: '张芳', initials: '张' },
    notes: '',
    orders: [],
    reminders: [],
  },
  'c5': {
    id: 'c5', name: 'Ahmed R.', company: 'Gulf Star Electronics', country: '🇶🇦 卡塔尔',
    avatarBg: '#FAC775', avatarColor: '#633806', initials: 'AR',
    platforms: ['telegram'], stage: 2,
    tags: ['电子元器件', '价格敏感'],
    assignee: { name: '王强', initials: '王' },
    notes: '对批量折扣非常感兴趣，需要进一步确认规格。',
    orders: [],
    reminders: [],
  },
  'c6': {
    id: 'c6', name: 'Julia P.', company: 'Lumos Retail', country: '🇵🇱 波兰',
    avatarBg: '#F4C0D1', avatarColor: '#72243E', initials: 'JP',
    platforms: ['facebook'], stage: 4,
    tags: ['零售', '已成交', '欧洲'],
    assignee: { name: '张芳', initials: '张' },
    notes: '样品已寄出，客户反馈良好，即将下正式订单。',
    orders: [],
    reminders: [],
  },
};

export const CONVERSATIONS = [
  {
    id: 'conv1', contactId: 'c1', platform: 'telegram', unread: 3,
    lastMessage: 'What is the MOQ for LED strips?', lastTime: '10:42',
    messages: [
      { id: 'm1', from: 'contact', text: 'Hello, I\'m interested in your LED strip lights. What is the minimum order quantity?', time: '10:31', translated: '你好，我对你们的LED灯带很感兴趣，最低起订量是多少？' },
      { id: 'm2', from: 'me', text: 'Hi Mohammed! Our MOQ for LED strips is 500 meters per color. We offer competitive pricing with bulk discounts for 2000m+.', time: '10:35' },
      { id: 'm3', from: 'contact', text: 'What about the IP rating? We need waterproof ones for outdoor use.', time: '10:38' },
      { id: 'm4', from: 'me', text: 'We have IP65 and IP68 options. IP68 is fully waterproof, suitable for underwater up to 1m. I\'ll send you our catalog with detailed specs right away.', time: '10:39' },
      { id: 'm5', from: 'contact', text: 'What is the MOQ for LED strips? Also can you send price list for IP68?', time: '10:42', translated: 'LED灯带MOQ是多少？能否发送IP68的价格表？' },
    ]
  },
  {
    id: 'conv2', contactId: 'c2', platform: 'whatsapp', unread: 0,
    lastMessage: 'Please send the catalog again', lastTime: '09:15',
    messages: [
      { id: 'm1', from: 'contact', text: 'Hi, I need to reorder industrial lights. Please send the catalog again.', time: '09:15' },
    ]
  },
  {
    id: 'conv3', contactId: 'c3', platform: 'email', unread: 0,
    lastMessage: 'Re: Quotation #2024-087', lastTime: '昨天',
    messages: [
      { id: 'm1', from: 'me', text: 'Dear Dmitri, please find attached our quotation #2024-087 for the LED industrial lights. We look forward to your feedback.', time: '昨天 16:00' },
      { id: 'm2', from: 'contact', text: 'Thank you. I will review and get back to you by end of week.', time: '昨天 17:30' },
    ]
  },
  {
    id: 'conv4', contactId: 'c4', platform: 'whatsapp', unread: 0,
    lastMessage: 'OK, let me confirm with our team', lastTime: '昨天',
    messages: [
      { id: 'm1', from: 'contact', text: 'OK, let me confirm with our team and I\'ll get back to you soon.', time: '昨天 14:22' },
    ]
  },
  {
    id: 'conv5', contactId: 'c5', platform: 'telegram', unread: 1,
    lastMessage: 'Can you offer better price for 1000pcs?', lastTime: '周一',
    messages: [
      { id: 'm1', from: 'contact', text: 'Can you offer better price for 1000pcs? This is a big order for us.', time: '周一 11:05', translated: '你们1000个能给更好的价格吗？这对我们来说是大订单。' },
    ]
  },
  {
    id: 'conv6', contactId: 'c6', platform: 'facebook', unread: 0,
    lastMessage: 'Thanks for the sample shipment', lastTime: '周一',
    messages: [
      { id: 'm1', from: 'contact', text: 'Thanks for the sample shipment! We received it and the quality looks great.', time: '周一 09:00' },
      { id: 'm2', from: 'me', text: 'Wonderful! We\'re glad you\'re happy with the samples. Ready to place the full order when you are!', time: '周一 09:30' },
    ]
  },
];

export const QUICK_REPLIES = [
  { id: 'qr1', label: '发送产品目录', text: 'Please find our latest product catalog attached. Let me know if you need more information about any specific product.' },
  { id: 'qr2', label: '报价单跟进', text: 'I wanted to follow up on the quotation we sent. Have you had a chance to review it? Feel free to ask if you have any questions.' },
  { id: 'qr3', label: '告知MOQ', text: 'Our minimum order quantity (MOQ) is 500 units per item. For orders above 2000 units, we offer special bulk pricing.' },
  { id: 'qr4', label: '安排样品', text: 'We\'d be happy to send you samples! Please provide your shipping address and contact details, and we\'ll arrange the sample shipment within 3 business days.' },
  { id: 'qr5', label: '付款方式', text: 'We accept T/T (Bank Transfer), L/C at sight, and PayPal for small orders. For new customers, we typically require 30% deposit and 70% before shipment.' },
];

export const CURRENT_USER = { name: '李小红', initials: '李', role: '外贸营销员' };
export const TEAM_MEMBERS = [
  { name: '李小红', initials: '李' },
  { name: '王强', initials: '王' },
  { name: '张芳', initials: '张' },
];
